import { CodeTypeModel } from '../../core/models/code-type';
import { JobStatusPipe } from './transaction-center.jobs.status.pipe';

export function JobStatus ( jobStatusPipe : JobStatusPipe ) {
  return ( value : string, statuses : Array<CodeTypeModel> ) : string => jobStatusPipe.transform(value, statuses);
}